import { Either } from "fp";

export namespace Result {
  export function decode<
    TypeName extends string,
    Fragment extends
      | ({ readonly __typename?: TypeName } & Encoded)
      | { readonly message: string },
    Encoded,
    Decoded
  >(_typeName: TypeName, _decode: (encoded: Encoded) => Decoded) {
    return (_fragment: Fragment): Either.ErrorOr<Decoded> => hole();
    // pipe(
    //   fragment,
    //   Either.fromPredicate(
    //     (fragment: Fragment): fragment is Encoded =>
    //       "__typename" in fragment && fragment.__typename === typeName,
    //     ({ message }) =>
    //       message
    //         ? Error(message)
    //         : Error(`Failed to decode \`${typeName}\` fragment.`)
    //   ),
    //   Either.map(decode)
    // );
  }
}
